import "./SimplePrompt.css";

const SimplePrompt = (props) => {

    return (
        <div className={"banner-prompt " + props.variant}>
            <div className="banner-prompt-text">
                {props.message}
            </div>
            <div className="banner-prompt-action">
                {props.actions}
            </div>
        </div>
    )

}

export default SimplePrompt;